import { render } from "./VaBeneIngredientListPage.vue?vue&type=template&id=14928620&ts=true"
import script from "./VaBeneIngredientListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneIngredientListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__